<script setup lang="ts">
import { computed } from "vue"
import { compactPrefixedId } from "../utils/format"
import ClippedValue from "./ClippedValue.vue"

const props = withDefaults(
  defineProps<{
    maxClass?: string
    prefix: string
    title: string
    value: string
  }>(),
  {
    maxClass: "max-w-[8rem]"
  }
)

const displayValue = computed(() => compactPrefixedId(props.value, props.prefix))
</script>

<template>
  <ClippedValue :display="displayValue" :max-class="maxClass" :title="title" :value="value" />
</template>
